/**
 * Determine location priority based on available sources
 * Priority: JWT session > localStorage > portal default
 * @param {Object} session - User session with location_id
 * @param {string} localStorageStoreView - Store view ID from localStorage
 * @param {Object} portal - Portal object with default_location
 * @returns {number|null} - Selected location ID or null
 */
export const getStoreViewPriority = (session, localStorageStoreView, portal) => {
  // Priority 1: JWT session location (user's saved preference)
  if (session?.location_id) return Number(session.location_id)

  // Priority 2: localStorage location (previously selected)
  if (localStorageStoreView && !isNaN(Number(localStorageStoreView))) return Number(localStorageStoreView)

  // Priority 3: Portal default location
  if (portal?.default_location?.id) return Number(portal.default_location.id)

  return null
}

/**
 * Check whether a store view is present in the user's assigned store views.
 * Guest/default-location rules are handled by canUseCurrentStoreView.
 * @param {string|number} storeViewId - Store view ID to validate
 * @param {Array} availableStoreViews - User's assigned store views
 * @returns {boolean} - Whether user has access to store view
 */
export const validateUserStoreViewAccess = (storeViewId, availableStoreViews) => {
  if (!availableStoreViews?.length) return false

  return availableStoreViews.some(storeView => storeView.id?.toString() === storeViewId?.toString())
}

export const canUseCurrentStoreView = ({ hasAuthToken, currentUser, currentStoreView, availableStoreViews }) => {
  if (!currentStoreView?.id) return false

  if (!hasAuthToken) return currentStoreView.is_default === true

  if (!currentUser?.id) return false

  if (!availableStoreViews?.length) return false

  return validateUserStoreViewAccess(currentStoreView.id, availableStoreViews)
}
